export default __webpack_public_path__ + "2db41bd017f4abe3870bd2f2ce458cdb.png";